import React, { useEffect, useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { MdOutlineClose } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import Select from "react-select";
import Pagination from '../../../Components/Pagination/Pagination';
import { AppliedTendersGet } from '../../../Redux/Action/Dashboard';
import { fileBaseUrl, formatDate, getUserDetail, statusStyles } from '../../../Utils/Helper';
import Loader from '../../../Utils/Loader';
import { errorNotify, successNotify } from '../../../Utils/Toast';
import downloadDocImg from "../../../images/download_doc_img.png";
import loseImg from "../../../images/lost_icon.png";
import userIcon from "../../../images/user_icon.png";
import winImg from "../../../images/won_icon.png";
import PreviewTenderDetails from '../InterestedTenders/PreviewTenderDetails';
import './AppliedTenders.css';
import SubmitStatusModal from './SubmitStatusModal';

const Documents = () => {
    const dispatch = useDispatch();

    const [show, setShow] = useState(false)
    const [saveStatus, setSaveStatus] = useState(null)
    const [tab, setTab] = useState("applied")
    const [tender_id, setTender_id] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [showDetails, setShowDetails] = useState(false)
    const [reviewData, setReviewData] = useState(null);
    const [resultDetails, setResultDetails] = useState({
        tender_result: null,
        tender_comment: ''
    })
    const [uploadedDocsModal, setUploadedDocsModal] = useState({
        show: false,
        type: '',
        tenderId: null
    })
    // Add new state for modal
    const [showAllAssignees, setShowAllAssignees] = useState({
        show: false,
        assignees: []
    });

    const { loading, getAppliedTendersData } = useSelector((state) => state.appliedTendersData)
    const { loading: applyLoading, applyTenderData, error } = useSelector((state) => state.getApplyTenderData)

    useEffect(() => {
        if (currentPage !== 1) {
            setCurrentPage(1);
        }
    }, [limit, tab]);

    useEffect(() => {
        dispatch({ type: "GET_ATTACHMENT_RESET" })
    }, [])

    useEffect(() => {
        const formData = new FormData();
        getUserDetail()?.role !== 'super-admin' && formData.append('department_id', getUserDetail()?.department_id)
        formData.append('search_type', tab);
        dispatch(AppliedTendersGet(formData, currentPage, limit))
    }, [tab, currentPage, limit]);

    useEffect(() => {
        if (applyTenderData?.statusCode === 200) {
            successNotify("Applied Successfully!");

            const formData = new FormData();
            formData.append('search_type', tab);
            {
                getUserDetail()?.role !== 'super-admin' &&
                    formData.append('department_id', getUserDetail()?.department_id)
            }

            dispatch(AppliedTendersGet(formData, currentPage, limit))
            setShow(false)
            dispatch({ type: "APPLY_FOR_TENDER_RESET" })
        }
        else if (error) {
            errorNotify(error)
            dispatch({ type: "APPLY_FOR_TENDER_RESET" })
        }
    }, [applyTenderData])

    const statusOption = [
        { value: 'won', label: 'Won' },
        { value: 'lost', label: 'Lost' },
    ]
    const handleDepartmentChange = (d, data) => {
        setTender_id(data?.id)
        setSaveStatus(d?.value)
        setShow(true)
    };

    const getUniqueAssignees = (assignees) => {
        const uniqueMap = new Map();
        assignees?.forEach(assignee => {
            if (!uniqueMap.has(assignee.user.id)) {
                uniqueMap.set(assignee.user.id, assignee);
            }
        });
        return Array.from(uniqueMap.values());
    };

    const resultDetailHandler = (tender) => {
        const tender_result = tender?.tender_docs?.filter((doc) => doc?.source_type === "tender_result")

        setResultDetails({
            ...resultDetails,
            tender_result,
            tender_comment: tender?.comment
        })

        setShowDetails(true)
    }

    const uploadedDocsHandler = (tender) => {
        setReviewData(tender)

        setUploadedDocsModal({
            show: true,
            type: 'Uploaded Docs',
            tenderId: tender?.id
        })
    }

    return (
        <div className='dashboard_main' style={{ padding: "15px 10px" }}>

            <SubmitStatusModal
                show={show}
                setShow={() => setShow(false)}
                saveStatus={saveStatus}
                setSaveStatus={setSaveStatus}
                applyLoading={applyLoading}
                tender_id={tender_id}
            />

            <PreviewTenderDetails
                uploadModal={uploadedDocsModal}
                setUploadModal={() => setUploadedDocsModal({ show: false, type: '', tenderId: null })}
                reviewData={reviewData}
                showApply={false}
            />

            <h1> Applied Tenders </h1>

            <div className='tender_tabs'>
                <p className={tab === 'applied' && 'active'} onClick={() => setTab('applied')}>Applied</p>
                <p className={tab === 'result' && 'active'} onClick={() => setTab('result')}>Results</p>
            </div>

            <div className='mt-3 mx-3'>
                {
                    loading ?
                        <Loader /> :
                        <Row style={{ gap: "15px 0" }}>
                            {
                                tab === 'applied' ?
                                    <>
                                        {
                                            getAppliedTendersData?.data?.results?.map((t, i) => {
                                                return (
                                                    <Col md={6} key={i}>
                                                        <div className={`interested_tender_box`}>
                                                            <Row className='align-items-center'>
                                                                <Col md={12}>
                                                                    <div>
                                                                        <div className='applied_tender_head'>
                                                                            <p><span>Tender No.</span> {t.tenderNo}</p>

                                                                            {
                                                                                getUserDetail()?.role !== 'user' &&
                                                                                <Form.Group className="form_field">
                                                                                    <Form.Label>Status</Form.Label>
                                                                                    <Select
                                                                                        onChange={(e) => handleDepartmentChange(e, t)}
                                                                                        options={statusOption}
                                                                                        placeholder="Select Status"
                                                                                        styles={statusStyles}
                                                                                        value={saveStatus ? saveStatus.value : null}
                                                                                    />
                                                                                </Form.Group>
                                                                            }
                                                                        </div>
                                                                        <p><span>Tender Company: </span> {t.company}</p>
                                                                        <div>
                                                                            <p><span>Assignees: </span></p>

                                                                            <div className='applied_tender_assignees'>
                                                                                {(() => {
                                                                                    const uniqueAssignees = getUniqueAssignees(t?.assignees);
                                                                                    const visibleAssignees = uniqueAssignees.slice(0, 3);
                                                                                    const remainingCount = uniqueAssignees.length - 3;

                                                                                    return (
                                                                                        <>
                                                                                            {visibleAssignees.map((a, i) => (
                                                                                                <div key={i}>
                                                                                                    <img
                                                                                                        src={a.user.image ? `${fileBaseUrl}/${a.user.image}` : userIcon}
                                                                                                        alt=""
                                                                                                    />
                                                                                                    <span className='applied_tender_assignee'>{a.user.user_name}</span>
                                                                                                </div>
                                                                                            ))}
                                                                                            {remainingCount > 0 && (
                                                                                                <div
                                                                                                    className="assignee-count"
                                                                                                    onClick={() => setShowAllAssignees({
                                                                                                        show: true,
                                                                                                        assignees: uniqueAssignees
                                                                                                    })}
                                                                                                    style={{
                                                                                                        width: "28px",
                                                                                                        height: "28px",
                                                                                                        borderRadius: "50%",
                                                                                                        backgroundColor: "#003A70",
                                                                                                        color: "#fff",
                                                                                                        display: "flex",
                                                                                                        alignItems: "center",
                                                                                                        justifyContent: "center",
                                                                                                        cursor: "pointer",
                                                                                                        fontSize: "12px",
                                                                                                        marginLeft: "5px"
                                                                                                    }}
                                                                                                >
                                                                                                    +{remainingCount}
                                                                                                </div>
                                                                                            )}
                                                                                        </>
                                                                                    );
                                                                                })()}
                                                                            </div>
                                                                        </div>
                                                                        <p><span>Department: </span> {t?.depart?.name} </p>
                                                                    </div>
                                                                </Col>
                                                                <Col md={12}>
                                                                    <div className='applied_tender_btn'>
                                                                        <button style={{ padding: '10px 40px', width: "auto" }} onClick={() => uploadedDocsHandler(t)}>Uploaded Docs.</button>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                )
                                            })
                                        }
                                    </> :
                                    <>
                                        {
                                            getAppliedTendersData?.data?.results?.map((t, i) => {
                                                return (
                                                    <Col md={6} key={i}>
                                                        <div className={`interested_tender_box ${t?.status === 'win' ? 'win' : 'lose'}`}>
                                                            <Row className='align-items-center'>
                                                                <Col md={12}>
                                                                    <div>
                                                                        <Row>
                                                                            <Col md={6}>
                                                                                <p><span>Tender No.</span> {t.tenderNo}</p>
                                                                            </Col>
                                                                            <Col md={6}>
                                                                                <p><span>Status</span> <b>{t?.status === 'win' ? "Won" : "Lose"} <img src={t?.status === 'win' ? winImg : loseImg} /></b> </p>
                                                                            </Col>
                                                                            <Col md={6}>
                                                                                <p><span>Award Date: </span> {formatDate(t?.updated_at)}</p>
                                                                            </Col>
                                                                            <Col md={6}>
                                                                                <p><span>Department: </span> {t?.depart?.name} </p>
                                                                            </Col>
                                                                            <Col md={12}>
                                                                                <p><span>Assignees: </span></p>

                                                                                <div className='applied_tender_assignees'>
                                                                                    {(() => {
                                                                                        const uniqueAssignees = getUniqueAssignees(t?.assignees);
                                                                                        const visibleAssignees = uniqueAssignees.slice(0, 3);
                                                                                        const remainingCount = uniqueAssignees.length - 3;

                                                                                        return (
                                                                                            <>
                                                                                                {visibleAssignees.map((a, i) => (
                                                                                                    <div key={i}>
                                                                                                        <img
                                                                                                            src={a.user.image ? `${fileBaseUrl}/${a.user.image}` : userIcon}
                                                                                                            alt=""
                                                                                                        />
                                                                                                        <span className='applied_tender_assignee'>{a.user.user_name}</span>
                                                                                                    </div>
                                                                                                ))}
                                                                                                {remainingCount > 0 && (
                                                                                                    <div
                                                                                                        className="assignee-count"
                                                                                                        onClick={() => setShowAllAssignees({
                                                                                                            show: true,
                                                                                                            assignees: uniqueAssignees
                                                                                                        })}
                                                                                                        style={{
                                                                                                            width: "28px",
                                                                                                            height: "28px",
                                                                                                            borderRadius: "50%",
                                                                                                            backgroundColor: "#003A70",
                                                                                                            color: "#fff",
                                                                                                            display: "flex",
                                                                                                            alignItems: "center",
                                                                                                            justifyContent: "center",
                                                                                                            cursor: "pointer",
                                                                                                            fontSize: "12px",
                                                                                                            marginLeft: "5px"
                                                                                                        }}
                                                                                                    >
                                                                                                        +{remainingCount}
                                                                                                    </div>
                                                                                                )}
                                                                                            </>
                                                                                        );
                                                                                    })()}
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </Col>
                                                                <Col md={12}>
                                                                    <div className='applied_tender_btn'>
                                                                        <button style={{ padding: '10px 40px', width: "auto" }} onClick={() => uploadedDocsHandler(t)}>Uploaded Docs.</button>
                                                                        <button style={{ padding: '10px 40px', backgroundColor: "#3CB779", width: "auto" }} onClick={() => resultDetailHandler(t)}>Details</button>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                )
                                            })
                                        }
                                    </>
                            }

                            {
                                getAppliedTendersData?.data?.results?.length > 0 &&
                                <Pagination
                                    totalPages={getAppliedTendersData?.data?.meta?.totalPages}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    setLimit={setLimit}
                                    limit={limit} />
                            }

                            {getAppliedTendersData?.data?.results?.length === 0 && <h5 style={{ fontWeight: "600" }} className='text-center my-3'>No Data Found</h5>}
                        </Row>
                }
            </div>


            <Modal centered className='doc_type' size='lg' show={showDetails} onHide={() => {
                setShowDetails(false)
                setResultDetails({
                    tender_result: null,
                    tender_comment: ''
                })
            }}>
                <Modal.Body>
                    <div className='add_doc_type'>
                        <div className='head'>
                            <h5>Details</h5>
                            <MdOutlineClose onClick={() => {
                                setShowDetails(false)
                                setResultDetails({
                                    tender_result: null,
                                    tender_comment: ''
                                })
                            }} />
                        </div>

                        {
                            resultDetails?.tender_comment?.length > 0 &&
                            <div className='atatchment_box px-5'>
                                <h5>Reason Comment</h5>

                                <p style={{
                                    color: "#000", border: "1px solid #DEDCDC",
                                    padding: "20px", borderRadius: "10px", fontWeight: "500", fontSize: "14px", textTransform: "none"
                                }}>
                                    {resultDetails?.tender_comment}
                                </p>

                            </div>
                        }

                        {resultDetails?.tender_result?.length > 0 && (
                            <div className='atatchment_box px-5'>
                                <h5>Attachments</h5>

                                <div className='attachments_wrapper'>
                                    <Row>
                                        {resultDetails?.tender_result.map((file) => {
                                            const fileURL = file?.media?.split('/')
                                            const fileformat = fileURL[fileURL.length - 1].split('.')
                                            return (
                                                <Col md={6} key={file.id}>
                                                    <a
                                                        href={`${fileBaseUrl}/${file.media}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                    >
                                                        <div className='attachment_item'>
                                                            <img src={downloadDocImg} alt='' width={'40px'} />
                                                            <div>
                                                                <h6>{fileURL[fileURL.length - 1]}</h6>
                                                                <span>File Format: {fileformat[fileformat.length - 1]}</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </Col>
                                            )
                                        })}
                                    </Row>
                                </div>
                            </div>
                        )}

                        {
                            resultDetails?.tender_comment?.length === 0 && resultDetails?.tender_result?.length === 0 &&
                            <h5 className='text-center'>No Data Found</h5>
                        }
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={showAllAssignees.show}
                onHide={() => setShowAllAssignees({ show: false, assignees: [] })}
                centered
            >
                <Modal.Body>
                    <div className='head' style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: "20px 20px"
                    }}>
                        <h5 style={{ marginBottom: "0px" }}>All Assignees</h5>
                        <MdOutlineClose style={{ fontSize: "20px", cursor: "pointer" }} onClick={() => setShowAllAssignees({ show: false, assignees: [] })} />
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", padding: "15px", cursor: "pointer" }}>
                        {showAllAssignees.assignees.map((a, i) => (
                            <div
                                key={i}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    padding: "10px",
                                }}
                            >
                                <img
                                    src={a.user.image ? `${fileBaseUrl}/${a.user.image}` : userIcon}
                                    alt=""
                                    style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        objectFit: "cover"
                                    }}
                                />
                                <span style={{
                                    color: "#003A70",
                                    fontWeight: "600",
                                    fontSize: "14px"
                                }}>
                                    {a.user.user_name}
                                </span>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
};

export default Documents;